import { deriveAuthContinueUrl } from '../utils';
import { useUrlQueryParam } from './useUrlQueryParam';

/**
 * Resolves where to send a user after auth completes by reading `inviteToken`
 * and `continueUrl` from the current URL and applying the auth-redirect
 * derivation (continueUrl wins; inviteToken folds into `/accept-invitation?…`).
 * Result passes through the same-origin guard, so callers can safely use it as
 * a redirect target.
 */
export const useAuthContinueUrl = (): string | null => {
  const inviteToken = useUrlQueryParam('inviteToken');
  const continueUrl = useUrlQueryParam('continueUrl');
  return deriveAuthContinueUrl(inviteToken, continueUrl);
};
